import { palette } from '@/theme/constants';

import { Box, Modal, Theme, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'next-i18next';
import { MuiButton, MuiIconButton } from '@/components';
import { styles } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { openModal, setPublication } from '@/store/actions';
import { storySelector } from '@/store/selectors';
import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { QRCodeCanvas } from 'qrcode.react';
import Image from 'next/image';
import { base_url } from '@/utils';
interface ModalDetailProps {
  extendedPalette?: any;
  add: boolean;
  onClose: () => void;
  mediaContent?: any;
  method: () => void;
  CloseManageCollaborators: () => void;
}

export const AddCollaborators = ({
  add,
  onClose,
  extendedPalette,
  CloseManageCollaborators,
  method,
}: ModalDetailProps) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const story = useSelector(storySelector);
  const [link, setLink] = useState(false);
  const [linkCode, setLinkCode] = useState(false);
  const [InviteLink, SetInviteLink] = useState('');
  const router = useRouter();
  const dispatch = useDispatch();

  useEffect(() => {
    const storyIdBase64 = btoa(story?.story?.id?.toString() || '');
    const referralCodeBase64 = story?.story?.user?.referral_code ? btoa(story?.story?.user?.referral_code.trim()) : '';
    const userTypeBase64 = btoa('friend');
    const roleBase64 = btoa('collaborator');

    const fullUrl = `${window.location.origin}/app/story/${story?.story?.url}?story_id=${storyIdBase64}&user_type=${userTypeBase64}&role=${roleBase64}`;
    SetInviteLink(fullUrl);
  }, [router, story]);
  const copyLink = () => {
    setLink(true);
    const message = `You've been invited to collaborate on a Memvy. Follow this link to join Memvy and start uploading memories:\n\n${InviteLink}`;

    navigator.clipboard.writeText(message).catch((err) => console.error('Failed to copy link:', err));

    setTimeout(() => setLink(false), 2000);
  };

  const qrRef = useRef<HTMLDivElement | null>(null);

  const handleDownload = () => {
    const canvas = qrRef.current?.querySelector('canvas');
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const a = document.createElement('a');
    a.href = url;
    a.download = 'qr_code.png';
    a.click();
  };

  const handleNavigate = () => {
    CloseManageCollaborators();
    onClose();
  };
  const handlePublication = (publication: any) => {
    if (publication === 'public') {
      dispatch(setPublication({ ...story.story, isPrivate: false }));
    } else if (publication === 'private') {
      dispatch(setPublication({ ...story.story, isPrivate: true }));
    } else {
      dispatch(setPublication({ ...story.story, isPrivate: true, newCode: true }));
    }
  };
  const copyLinkCode = () => {
    setLinkCode(true);
    navigator.clipboard.writeText(`${base_url}${router?.asPath}?code=${story?.story?.password}`);
    setTimeout(() => setLinkCode(false), 2000);
  };

  return (
    <Modal open={add} onClose={onClose} sx={styles.modal}>
      <Box
        display={'flex'}
        width={isMobile ? '100%' : '100%'}
        mx={isMobile ? '2rem' : '0'}
        height={isMobile ? '100%' : '100%'}
        paddingTop={isMobile ? '4rem' : ''}
        maxHeight={isMobile ? '100%' : '100%'}
        bgcolor={!isMobile ? `rgba(33, 45, 109, 0.8)` : 'transparent'}
        flexDirection={'column'}
        justifyContent={isMobile ? 'flex-start' : 'center'}
        alignItems={'center'}
        alignContent={'center'}
        position={'relative'}
        overflow={'hidden'}>
        <Box
          width={'350px'}
          maxWidth={'100%'}
          height={'665px'}
          maxHeight={isMobile ? '100%' : '100%'}
          position={'absolute'}
          py={1}
          borderRadius={'20px'}
          alignItems={'center'}
          textAlign={'center'}
          overflow={'auto'}
          bgcolor={palette?.white}>
          {/* Title */}
          <Typography fontSize={'1rem'} px={6} color='#000000' textAlign='center' my={2}>
            Invite collaborators
          </Typography>
          {/* <Form onClose={onClose} extendedPalette={extendedPalette} /> */}

          {/* Subtitle */}
          <Typography fontSize={'0.8rem'} color='#000000' textAlign='center' mb={2}>
            Copy this link and share this memvy with anyone to collaborate.
          </Typography>

          {/* Copy Link Button */}
          <MuiIconButton
            direction='true'
            isRounded={false}
            borderRadius={2}
            width={284}
            height={56}
            disableRipple={true}
            background='rgba(216, 232, 246, 1)'
            method={copyLink}
            label={link ? 'Copied' : 'Copy Link'}
            positionIcon='left'
            labelColor='#000000'
            icon='/icons/copy'
            altIcon='copy'
            sx={{ gap: '1rem' }}
            iconWidth={18}
            iconHeight={18}
          />
          {story?.story?.private && (
            <MuiIconButton
              direction='true'
              isRounded={false}
              borderRadius={2}
              width={284}
              height={56}
              disableRipple={true}
              background='rgba(216, 232, 246, 1)'
              method={() => copyLinkCode()}
              label={linkCode ? 'Copied' : 'Copy Link With Code'}
              positionIcon='left'
              labelColor='#000000'
              icon='/icons/copy'
              altIcon='copy'
              sx={{ gap: '1rem', mt: '1rem' }}
              iconWidth={18}
              iconHeight={18}
            />
          )}
          {/* QR Code */}
          <Typography fontSize={'0.8rem'} color='#000000' textAlign='center' my={2}>
            or share the QR code below.
          </Typography>

          <Box ref={qrRef} sx={{ my: 2 }}>
            <QRCodeCanvas
              value={`You've been invited to collaborate on a Memvy. Follow this link to join Memvy and start uploading memories:\n\n${InviteLink}`}
              size={172}
              level='H'
            />
          </Box>
          <MuiIconButton
            direction='true'
            isRounded={false}
            borderRadius={2}
            width={284}
            height={56}
            disableRipple={true}
            background='rgba(216, 232, 246, 1)'
            label='Download QR Code'
            labelColor='#000'
            sx={{ gap: '1rem' }}
            iconWidth={18}
            iconHeight={18}
            method={handleDownload}
            icon={'/icons/download'}
            altIcon={'download'}
          />
          {story?.story?.private && (
            <>
              <Box
                display={'flex'}
                margin={'auto'}
                width={284}
                mt={2}
                padding={'1rem'}
                style={{
                  backgroundColor: 'rgba(216, 232, 246, 1)',
                  borderRadius: '10px',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
                color={palette.black}>
                <Typography fontSize={'1rem'} color='#000000' textAlign='center'>
                  {t(`${story?.story?.password}`)}
                </Typography>
                <Image
                  onClick={() => handlePublication('newCode')}
                  style={{ cursor: 'pointer' }}
                  src='/icons/regenerate.svg'
                  alt='new-code'
                  width={24}
                  height={24}
                />
              </Box>
            </>
          )}

          {/* Footer Text */}

          <MuiIconButton
            direction='true'
            isRounded={false}
            borderRadius={2}
            iconPosition={'left'}
            width={284}
            height={56}
            disableRipple={true}
            background='#212D6D'
            label='Done'
            labelColor='#fff'
            sx={{ gap: '1rem', mt: '1rem', borderRadius: '10px' }}
            iconWidth={18}
            iconHeight={18}
            method={onClose}
            icon={'/icons/tick'}
            altIcon={'tick'}
          />
          <Typography
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
            onClick={handleNavigate}
            fontSize={'0.8rem'}
            color='#000000'
            my={2}
            textAlign='center'>
            Want to manage existing collaborators?
          </Typography>
        </Box>
      </Box>
    </Modal>
  );
};
